import { Link } from 'react-router';

export function Logo({ to = '/', label }: { to?: string; label?: string }) {
  return (
    <Link to={to} className="flex min-h-11 items-center gap-3" aria-label="MindHYVE Partner Hub home">
      <img src="/brand/MH_Logo_Master_2_White.svg" alt="MindHYVE.ai" width={132} height={30} className="h-7 w-auto" />
      {label && <span className="hidden font-mono text-[11px] tracking-[0.2em] text-gold uppercase sm:inline">{label}</span>}
    </Link>
  );
}

export function Footer() {
  return (
    <footer className="mt-16 border-t border-line">
      <div className="mx-auto max-w-6xl px-4 py-6 text-sm leading-relaxed text-dim">
        <p className="text-ash">MindHYVE.ai, Inc.</p>
        <p>1501 Quail St, Suite 130 · Newport Beach, CA 92660 · United States</p>
        <p>
          <a className="hover:text-ink" href="tel:+19492008668">+1-949-200-8668</a> · <a className="hover:text-ink" href="mailto:partners@mindhyve.ai">partners@mindhyve.ai</a> ·{' '}
          <a className="hover:text-ink" href="https://mindhyve.ai">mindhyve.ai</a>
        </p>
      </div>
    </footer>
  );
}
